export default __webpack_public_path__ + "static/media/RectangleLeft.28bd9602.svg";